module.exports = __webpack_public_path__ + "img/remove_shopping_cart.e38ea2a1.svg";